
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.772 3.075a1.536 1.536 0 001.435-1.01h2.196a.507.507 0 00.49-.514.502.502 0 00-.49-.508h-2.196a1.522 1.522 0 00-2.875 0H.609a.501.501 0 00-.507.508.507.507 0 00.507.514h6.729a1.53 1.53 0 001.434 1.01zm0-.781a.737.737 0 01-.742-.749.743.743 0 011.485 0 .737.737 0 01-.743.749zM.584 4.916a.502.502 0 00-.482.514.496.496 0 00.482.508h2.272a1.522 1.522 0 002.876 0h6.646a.507.507 0 00.514-.508.512.512 0 00-.514-.514H5.726a1.524 1.524 0 00-2.87 0zm3.707 1.256a.743.743 0 110-1.485.743.743 0 010 1.485zm4.481 4.66a1.526 1.526 0 001.435-1.016h2.196a.502.502 0 00.49-.508.507.507 0 00-.49-.514h-2.196a1.524 1.524 0 00-2.87 0H.61a.507.507 0 00-.507.514.501.501 0 00.507.508h6.723a1.541 1.541 0 001.44 1.015zm0-.781a.736.736 0 01-.742-.743.743.743 0 111.485 0 .736.736 0 01-.743.743z"}})])
          )
        }
      }
    